import { useEffect, useRef, useState } from "react";

/**
 * Holder en flate montert til utgangen er ferdig.
 *
 * Flatene her kommer inn med en bevegelse og forsvant i ett bilde, fordi
 * komponenten returnerte null i samme oeyeblikk som tilstanden slo om. En
 * flate skal gaa ut slik den kom inn — se ~/.claude/skills/animate.
 *
 * `mounted` sier om noe skal tegnes, `shown` om det skal staa inne. Den som
 * bruker den setter `--in`-klassen etter `shown` og returnerer null naar
 * `mounted` er usann.
 *
 * Varigheten maa matche overgangen i stilarket. Menyen gjoer det samme for
 * haand; denne finnes for at det ikke skal skrives en tredje gang.
 */
export function useExitDelay(open: boolean, ms: number): { mounted: boolean; shown: boolean } {
  const [mounted, setMounted] = useState(open);
  const [shown, setShown] = useState(false);
  const timer = useRef(0);

  useEffect(() => {
    window.clearTimeout(timer.current);
    if (open) {
      setMounted(true);
      // Ett bilde foer klassen settes, ellers er det ingen overgang aa kjoere.
      timer.current = window.setTimeout(() => setShown(true), 20);
    } else {
      setShown(false);
      timer.current = window.setTimeout(() => setMounted(false), ms);
    }
    return () => window.clearTimeout(timer.current);
  }, [open, ms]);

  return { mounted, shown };
}
